import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {CmsComponentData} from '@spartacus/storefront';
import {Observable} from 'rxjs';

import {AimoCMSLandingPageTextComponent} from '../../../model/cms.model';

@Component({
    selector: 'aimo-landing-page-text',
    templateUrl: './aimo-landing-page-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoLandingPageTextComponent implements OnInit {
    data$: Observable<AimoCMSLandingPageTextComponent>;

    constructor(protected componentData: CmsComponentData<AimoCMSLandingPageTextComponent>) {
    }

    ngOnInit(): void {
        this.data$ = this.componentData.data$;
    }

    getBgClass(data: AimoCMSLandingPageTextComponent): string {
        return 'bg-' + data?.backgroundColor?.toLowerCase().replace('_', '-');
    }
}
